module.exports = __webpack_public_path__ + "img/zhdun.1672f8c.svg";